module.exports = __webpack_public_path__ + "img/Image_07.f2f69eec.jpg";